import { Department } from '@/module/Department/model/DepartmentTypes';
import { UserInfo } from '@/module/Nomen/User/model/UserModel';

import { IdentityRequest } from '@/feature/utils';

export interface Faculty {
  id: number;
  name: string;
  headOfFaculty: UserInfo;
  teachersNo: number;
  domain: FacultyDomain;

  departments: Department[];
}

export interface FacultyRequest {
  name: string;
  headOfFaculty: IdentityRequest;
  teachersNo: number;
  domain: FacultyDomain;
}

export const facultyDomainList = ['MEDICAL', 'RESEARCH', 'TECH'] as const;
export type FacultyDomain = (typeof facultyDomainList)[number];
